import React, { useState } from 'react';
import {
    DataTable,
    TableContainer,
    TableToolbarSearch,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
    TableToolbar,
    TableToolbarContent,
    Button,
    Loading,
} from '@carbon/react';
import { useNavigate } from "react-router-dom";
import { Edit, Link as LinkIcon, TrashCan, ArrowRight } from '@carbon/react/icons';
import endpoints from '../constants/endpoints.constants'
import { genericRequest } from "../utils/request";
import { compareAlphabetically, compareDates } from "../utils/sort";

// Landing page style for toolbar buttons
const toolbarButtonStyle = {
    padding: '17px',
    width: '250px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px'
};

const iconStyle = {
    marginLeft: '10px',
    fill: 'white'
};

const YoutubeStoriesList = (props) => {
    const navigate = useNavigate();
    const [requestStatusDelete, setRequestStatusDelete] = useState({
        isError: false,
        isSuccess: false,
        isLoading: false,
    });

    const deleteStory = async ({ videoId }) => {
        if (!window.confirm("Do you really want to delete?")) {
            return false
        }

        setRequestStatusDelete({ isLoading: true });

        const request = await genericRequest({
            endpoint: 'deleteYoutubeVideo',
            method: "POST",
            data: { videoId },
        });

        if (request.error) {
            return setRequestStatusDelete({ isError: true, isLoading: false });
        }

        props.storyList.splice(props.storyList.findIndex(story => story.id === videoId), 1)
        return setRequestStatusDelete({ isSuccess: true, isLoading: false });
    };

    const headerData = [
        {
            header: "Title",
            key: "video_title",
        },
        /*
        {
            header: "Publish Date",
            key: "publish_date",
        },
        */
        {
            header: "Categories",
            key: "video_categories",
        },
        {
            header: "Link",
            key: "embed_link",
        },
        {
            header: "Views",
            key: "view_count",
        },
        {
            header: "Shares",
            key: "share_count",
        },
        {
            header: "Edit",
            key: "edit",
        },
        {
            header: "Delete",
            key: "deleteStory",
        },
    ];

    /*
    if (props.userData.isAdmin) {
        headerData.push(
            {
                header: "Approved",
                key: "approval",
            },
            {
                header: "Ads Enabled",
                key: "approval_ads",
            }
        )
    }
    */

    const compare = (cellA, cellB, rowId) => {
        if (rowId === "publish_date") {
            return compareDates(cellA, cellB);
        }

        return compareAlphabetically(cellA, cellB);
    }

    return (
        <>
            <Loading active={requestStatusDelete.isLoading} withOverlay={true} />
            <DataTable isSortable
                headers={headerData}
                sortRow={(cellA, cellB, data) => {
                    if (data.sortDirection === data.sortStates.DESC) {
                        return compare(cellB, cellA, data.key);
                    }

                    return compare(cellA, cellB, data.key);
                }}
                rows={
                    props.storyList.map((story, key) => {
                        return (
                            {
                                id: story.id.toString(),
                                video_title: story.videoTitle,
                                // publish_date: story.publishDate ? `${moment(new Date(story.publishDate)).format('MMMM Do YYYY')}` : 'N/A',
                                video_categories: story.videoCategories, // Assuming it's already a string or we join it if array
                                embed_link: (
                                    <a target="_blank"
                                        rel="noopener noreferrer"
                                        href={story.embedLink}
                                    >
                                        <LinkIcon />
                                    </a>
                                ),
                                view_count: story.viewCount || 0,
                                share_count: story.shareCount || 0,
                                /*
                                approval: (
                                    <div>
                                        <Toggle
                                            size="sm"
                                            aria-label="Approval Toggle"
                                            defaultToggled={story.isApproved}
                                            id={`approval-toggle-${story.id}`}
                                            labelText={''}
                                            disabled={requestStatusEdit[key] ? requestStatusEdit[key].isLoading : false}
                                            onClick={async (event) => {
                                                event.persist()
                                                await toggleApproval({
                                                    videoId: story.id,
                                                    approvalListId: key,
                                                    approvalStatus: event.target.checked,
                                                    event,
                                                    isAds: false,
                                                })
                                            }}
                                        />
                                    </div>
                                ),
                                approval_ads: (
                                    <div>
                                        <Toggle
                                            size="sm"
                                            aria-label="Approval Toggle Show Ads"
                                            defaultToggled={story.isApprovedAds}
                                            id={`approval-toggle-${story.id}-ads`}
                                            labelText={''}
                                            disabled={requestStatusEdit[key] ? requestStatusEdit[key].isLoading : false}
                                            onClick={async (event) => {
                                                event.persist()
                                                await toggleApproval({
                                                    videoId: story.id,
                                                    approvalListId: key,
                                                    approvalStatus: event.target.checked,
                                                    event,
                                                    isAds: true,
                                                })
                                            }}
                                        />
                                    </div>
                                ),
                                */
                                edit: (
                                    <button
                                        className={'cds--btn--ghost'}
                                        rel="noopener noreferrer"
                                        onClick={() => navigate(endpoints.youtubeStoryDetails({ videoId: story.id }))}
                                        type="button"
                                    >
                                        <Edit />
                                    </button>
                                ),
                                deleteStory: (
                                    <button
                                        className={'cds--btn--ghost'}
                                        rel="noopener noreferrer"
                                        onClick={() => deleteStory({ videoId: story.id })}
                                        type="button"
                                    >
                                        <TrashCan />
                                    </button>
                                ),
                            }
                        )
                    }
                    )
                }
                render={({ rows, headers, getHeaderProps }) => (
                    <TableContainer
                        title="Youtube Story List"
                        description={
                            <span><br />Your Youtube Stories Will Be Shown Here</span>
                        }>
                        <TableToolbar>
                            <TableToolbarContent>
                                <Button
                                    tabIndex={1}
                                    onClick={() => navigate(endpoints.createYoutubeStory())}
                                    kind="primary"
                                    style={toolbarButtonStyle}>
                                    Add New Youtube Story <ArrowRight style={iconStyle} />
                                </Button>
                                <TableToolbarSearch onChange={props.storyListFilter} />
                            </TableToolbarContent>
                        </TableToolbar>
                        <Table useZebraStyles size='md'>
                            <TableHead>
                                <TableRow>
                                    {headers.map(header => {
                                        const { key, ...headerProps } = getHeaderProps({ header });
                                        return (
                                            <TableHeader key={key} {...headerProps}>
                                                {header.header}
                                            </TableHeader>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map(row => (
                                    <TableRow key={row.id}>
                                        {row.cells.map(cell => (
                                            <TableCell key={cell.id}>{cell.value}</TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            />
        </>
    );
};

export default YoutubeStoriesList;
